import { CompChildren } from '@fable/types'
import {
  StatsProfileSection,
  StatsProfileSectionProps,
} from './components/section'
import { StatsProfileHabits, StatsProfileStreaks } from './components/sections'
import { FlexBox } from '@fable/components'
import { css } from '@fable/theme'
import { StatsProfileHero } from './components/hero'

interface SectionProps extends StatsProfileSectionProps {
  content: CompChildren
}

export const StatsProfileSections = () => {
  const sections: SectionProps[] = [
    {
      type: 'hero',
      content: <StatsProfileHero />,
    },
    {
      type: 'sectionAlt',
      title: 'Reading Streaks',
      content: <StatsProfileStreaks />,
    },
    {
      type: 'sectionAlt',
      title: 'Reading Insights',
      content: <StatsProfileHabits />,
    },
  ]

  return (
    <FlexBox
      className={css`
        width: 100%;
        position: relative;
      `}
      flexDirection="column"
    >
      {sections.map(({ content, ...props }, i) => (
        <StatsProfileSection key={i} {...props}>
          {content}
        </StatsProfileSection>
      ))}
    </FlexBox>
  )
}
